const getFileExtensionFromUrl = (url) => {
  return (
    typeof url === "string" && url.split(/[#?]/)[0].split(".").pop().trim()
  );
};

export default getFileExtensionFromUrl;
